import { Injectable } from '@angular/core';
import { generateUUID } from '@com-delta-idp/mnx-utils';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  LoginOAuth,
  OauthAEMConfig,
  SwapAuthForAccessTokens
} from '../../models';
import { UtilMethodsService } from './util-methods.service';
import { UtilServiceHelperSupportService } from './util-service-helper-support.service';

@Injectable({
  providedIn: 'root'
})
export class UtilServiceHelperService extends UtilServiceHelperSupportService {
  constructor(protected override utilMethodsService: UtilMethodsService) {
    super(utilMethodsService);
  }

  createPostWithCredParam(
    authConfig: OauthAEMConfig,
    rememberedCheckedPrevously: boolean,
    authIdParam = '',
    lastNameFormControlValueParam = '',
    uniqueIdentifier = '',
    authorizationId?: string,
    encryptedTokenParam?: string,
    requestInput?: ILoginUserNamePasswordInput,
    rememberMeFlowWithPromptLogin?: boolean
  ): LoginAuthWithCredentialsParams {
    let payloadObject: LoginAuthWithCredentialsParams = {};
    let rememberMeWithPromptLogin = false;
    const commonProperties = {
      oauthConfig: authConfig,
      flowId: authorizationId,
      authId: authIdParam
    };

    rememberMeWithPromptLogin =
      this.isAuthConfigAndRememberMeFlowWithPromptLogin(
        authConfig,
        rememberMeFlowWithPromptLogin
      );

    if (rememberedCheckedPrevously) {
      payloadObject = {
        ...commonProperties,
        fingerPrint: uniqueIdentifier,
        encryptedToken: encryptedTokenParam
      };
    } else if (uniqueIdentifier) {
      payloadObject = this.utilMethodsService.isRequestInputUniqueIdentifier(
        requestInput,
        commonProperties,
        uniqueIdentifier,
        lastNameFormControlValueParam
      );
    } else if (
      this.utilMethodsService.isRememberMeApiFlowEnableFalse(
        authConfig,
        rememberMeWithPromptLogin
      )
    ) {
      payloadObject = {
        ...commonProperties,
        userNamePasswordFields: requestInput,
        lastNameFormControlValue: lastNameFormControlValueParam
      };
    }

    return payloadObject;
  }

  isAuthConfigAndRememberMeFlowWithPromptLogin(
    authConfig: OauthAEMConfig,
    rememberMeFlowWithPromptLogin: boolean | undefined
  ): boolean {
    return !!(
      authConfig.REMEMBERME_API_FLOW_ENABLE && rememberMeFlowWithPromptLogin
    );
  }

  checkForAccessDenied(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return (
      authResponse.code === 'access_denied' ||
      this.isAuthResponseErrorMessage(authResponse) === 'access_denied'
    );
  }

  isAuthResponseErrorMessage(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    if (
      authResponse.error?.details &&
      authResponse.error?.details[0] &&
      authResponse.error?.details[0].userMessage
    ) {
      return this.splitUserMessage(authResponse.error?.details[0].userMessage);
    }
    return '';
  }

  checkForPFCredentialValidationCode(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    let invalidCredentialError = false;
    const message =
      authResponse.error?.details &&
      authResponse.error?.details[0] &&
      authResponse.error?.details[0].userMessage
        ? this.splitUserMessage(authResponse.error?.details[0].userMessage)
        : '';
    invalidCredentialError = message === 'PF_CREDENTIAL_VALIDATION_FAILED';
    return invalidCredentialError;
  }

  setLocalStorageValue(key: string, value: string) {
    let result = false;
    if (this.isLocalStorageSupported()) {
      localStorage.setItem(key, value);
      result = true;
    }
    return result;
  }

  generateUniqueIdentifier(): string {
    let uniqueId = '';
    // if (typeof self.crypto.randomUUID() === 'function') {
    // uniqueId = self.crypto.randomUUID();
    // } else {
    uniqueId = generateUUID();
    // }
    return uniqueId;
  }
}
